import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {Button, Icon, Modal, Tooltip} from "antd"
import {retryGenLabel} from "../../../../../services/api/labelApi"

class Actions extends Component {
    constructor(props) {
        super(props)

        this.state = {
            loading: false,
            message: '',
            error: ''
        }
    }

    _onTryParseLabel = (item) => {
        Modal.confirm({
            content: 'Bạn chắc chắn muốn xử lý lại file label pdf này?',
            cancelText: 'Hủy',
            okText: 'Đồng ý',
            onOk: () => this._tryProcessJobParseLabel(item),
        })
    }

    _onError = (error) => {
        Modal.error({
            title: 'Lỗi',
            content: error
        })
    }

    _onSuccess = (message) => {
        Modal.success({
            title: 'Thành công',
            content: message
        })
    }

    _tryProcessJobParseLabel = async (item) => {
        this.setState({
            loading: true,
            message: '',
            error: ''
        })
        try {
            const id = item._id

            const {'data': response} = await retryGenLabel(id)

            const {success, error} = response

            if (!success) {
                return this.setState({
                    loading: false,
                    error: error
                }, () => {
                    this._onError(error)
                })
            }

            this.setState({
                loading: false
            }, () => {
                const {getListingJob} = this.props

                this._onSuccess('Đã chuyển server xử lý lại thành công!')

                if (typeof getListingJob === 'function') {
                    getListingJob()
                }
            })
        } catch (error) {
            this.setState({
                loading: false,
                error: error.message
            }, () => {
                this._onError(error.message)
            })
        }
    }

    render() {
        const {loading} = this.state
        const {item} = this.props

        return (
            <td className="Actions">
                <Tooltip title="Xử lý lại file pdf">
                    <Button type='danger' onClick={() => this._onTryParseLabel(item)}>
                        {loading ? <Icon type="sync" spin/> : <Icon type="redo"/>}
                    </Button>
                </Tooltip>
            </td>
        )
    }
}

Actions.propTypes = {
    item: PropTypes.object,
    getListingJob: PropTypes.func
}

export default Actions
